import { createSelector } from 'reselect';
import { createDepositPayAvailabilityMessage } from 'lib/search/createDepositPayAvailabilityMessage';
import { getIsDomestic } from './getIsDomestic';
import { getQueryCheckIn, getQueryClassicRewards } from './querySelectors';
import { getIsLoading } from './searchSelectors';

export const getDepositPayAvailabilityMessage = createSelector(
  getIsLoading,
  getIsDomestic,
  getQueryCheckIn,
  getQueryClassicRewards,
  createDepositPayAvailabilityMessage,
);
